import React, { useMemo, memo, useCallback } from "react";
import OrgLogo from "../../Assets/Main/Utils/org-logo.png";
import { useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "./sidebar.css";

const HIDDEN_ITEMS = new Set(["cab Settings", "create coupons"]);

const SideBarItem = memo(({ item, isActive, onClick }) => {
  const isDeals = item.name === "deals";
  const displayName = isDeals
    ? "Deals & Offers"
    : item.name.charAt(0).toUpperCase() + item.name.slice(1);

  return (
    <div
      onClick={onClick}
      className={`sidebar-menu-item ${isActive ? "active" : ""}`}
    >
      {item.image && (
        <img
          style={{ width: "22px", height: "22px" }}
          src={item.image}
          alt={item.name || ""}
        />
      )}
      <div>{displayName}</div>
    </div>
  );
});

const SideBar = () => {
  const { admin, payment_executive } = useSelector((state) => state.admin);

  const loggedUser = useMemo(() => {
    return admin?.data ? admin : payment_executive;
  }, [admin, payment_executive]);

  const location = useLocation();
  const navigate = useNavigate();

  const handleClick = useCallback((item) => {
    const role = loggedUser?.data?.role;
    const isDeals = item.name === "deals";

    if (isDeals) {
      navigate("/dealsAndOffers");
    } else if (role === "payment_executive" && item.name_with_underscore === "bookings") {
      navigate(`/bookings/payment_exec/${loggedUser?.data?._id}`);
    } else {
      navigate(`/${item.name_with_underscore}`);
    }
  }, [navigate, loggedUser]);

  return (
    <div className="sidebar border-24">
      <div className="sidebar-content">
        <div className="sidebar-logo flex-container flex-center" style={{ marginRight: "3px" }}>
          <Link to="/dashboard">
            <img style={{ width: "160px", height: "62px" }} src={OrgLogo} alt="logo" />
          </Link>
        </div>

        <div className="sidebar-menu">
          {loggedUser?.data?.access ? (
            loggedUser.data.access.map((item) => {
              if (HIDDEN_ITEMS.has(item.name)) return null;

              const path = item.name === "deals"
                ? "/dealsAndOffers"
                : `/${item.name_with_underscore}`;

              const isActive = location.pathname === path;

              return (
                <SideBarItem
                  key={item.name_with_underscore}  // ✅ stable key, not index
                  item={item}
                  isActive={isActive}
                  onClick={() => handleClick(item)}
                />
              );
            })
          ) : (
            <p>No Access</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default SideBar;